import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ExternalRedirect } from './components/ExternalRedirect';
import { Layout } from './layouts/Layout';
import { AgentPulse } from './pages/AgentPulse';
import { EUAIActZertifikat } from './pages/EUAIActZertifikat';
import { Home } from './pages/Home';
import { IKP3M } from './pages/IKP3M';
import { KiWirdMitarbeiter } from './pages/KiWirdMitarbeiter';
import { M365CopilotStarterKit } from './pages/M365CopilotStarterKit';
import { M365ImBlindflug } from './pages/M365ImBlindflug';
import { M365SecurityWebinar } from './pages/M365SecurityWebinar';
import { ShareGateAnfrage } from './pages/ShareGateAnfrage';
import { WorldBackupDay2026 } from './pages/WorldBackupDay2026';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<ExternalRedirect to="https://www.lansco.de" />} />
          <Route path="/overview" element={<Home />} />
          <Route path="/m365copilotstarterkit" element={<M365CopilotStarterKit />} />
          <Route path="/ikp3m" element={<IKP3M />} />
          <Route path="/m365securitywebinar" element={<M365SecurityWebinar />} />
          <Route path="/sharegate/anfrage" element={<ShareGateAnfrage />} />
          <Route path="/worldbackupday2026" element={<WorldBackupDay2026 />} />
          <Route path="/ki-wird-mitarbeiter" element={<KiWirdMitarbeiter />} />
          <Route path="/eu-ai-act/zertifikat" element={<EUAIActZertifikat />} />
          <Route path="/securityservice" element={<M365ImBlindflug />} />
          <Route path="/agentpulse" element={<AgentPulse />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;